<template>
  <div class="vd-gl-content">
    <a-row type="flex" class="vd-table-head">
      <a-col flex="auto" class="vd-table-name"> 菜单规则</a-col>
      <a-col class="vd-table-tool">
        <a-button type="primary" icon="plus" @click="createMenu">
          新建
        </a-button>
        <a-divider type="vertical" />
        <a-icon class="common-icon" type="reload"></a-icon>
      </a-col>
    </a-row>
    <a-table
      :data-source="list"
      :pagination="false"
      :loading="loading"
      row-key="id"
      size="small"
    >
      <a-table-column title="菜单名称" data-index="name">
        <template slot-scope="name, item">
          <a-icon :type="item.icon" /> {{ name }}
        </template>
      </a-table-column>
      <a-table-column align="center" title="权重" data-index="weigh" />
      <a-table-column title="路径" data-index="path" />
      <a-table-column align="center" title="是否菜单" data-index="is_menu">
        <template slot-scope="text">
          <a-icon class="common-icon" :type="text === 1 ? 'check' : 'close'" />
        </template>
      </a-table-column>
      <a-table-column align="center" title="操作">
        <template slot-scope="record">
          <a-tooltip title="修改">
            <a-icon
              type="edit"
              class="common-icon"
              @click="changeMenu(record)"
            />
          </a-tooltip>
          <a-tooltip :title="record.status === 1 ? '禁用菜单' : '启用菜单'">
            <a-popconfirm
              :title="
                record.status === 1
                  ? '禁用本目录和子目录'
                  : '启用本目录和子目录'
              "
              :ok-text="record.status === 1 ? '禁用' : '启用'"
              cancel-text="取消"
              @confirm="modifyMenuStatus(record.id, record.status)"
            >
              <a-icon
                slot="icon"
                type="exclamation-circle"
                :style="{ color: record.status === 1 ? 'red' : 'green' }"
              />
              <a-icon
                class="common-icon"
                :type="record.status === 1 ? 'eye' : 'eye-invisible'"
              />
            </a-popconfirm>
          </a-tooltip>
          <a-tooltip title="删除">
            <a-popconfirm
              title="删除本目录和子目录"
              ok-text="删除"
              cancel-text="取消"
              @confirm="deleteMenu(record.id)"
            >
              <a-icon slot="icon" type="question-circle-o" style="color: red" />
              <a-icon type="delete" class="common-icon" />
            </a-popconfirm>
          </a-tooltip>
        </template>
      </a-table-column>
    </a-table>

    <!--  对话框 modal 弹出层 -->
    <a-modal
      v-model="visible"
      :title="modalType ? '修改菜单' : '新建菜单'"
      ok-text="确认"
      cancel-text="取消"
      @ok="confirm"
      @cancel="cancel"
      :confirm-loading="confirmLoading"
    >
      <a-form-model
        ref="ruleForm"
        :model="form"
        layout="horizontal"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 14 }"
        :rules="rules"
      >
        <a-form-model-item label="是否菜单" prop="switchStatus">
          <a-switch
            checked-children="是"
            un-checked-children="否"
            v-model="form.switchStatus"
            :checked="form.switchStatus"
          />
        </a-form-model-item>

        <a-form-model-item label="父级菜单" prop="parentPath">
          <a-cascader
            style="width: 216px"
            :options="this.list"
            v-model="form.parentPath"
            :field-names="{
              label: 'name',
              value: 'id',
              children: 'children',
            }"
            placeholder="不选择的话默认为顶级菜单"
            :change-on-select="true"
          />
        </a-form-model-item>
        <a-form-model-item label="菜单名称" prop="name">
          <a-input
            class="vd-input-s"
            v-model="form.name"
            placeholder="菜单显示名称"
          />
        </a-form-model-item>
        <a-form-model-item label="权重" prop="weigh">
          <a-input-number v-model="form.weigh" />
        </a-form-model-item>
        <a-form-model-item label="路径" prop="path">
          <a-input
            class="vd-input-s"
            v-model="form.path"
            placeholder="请输入绝对路径"
          />
        </a-form-model-item>
        <a-form-model-item label="图标" prop="icon">
          <a-input
            class="vd-input-xs"
            placeholder="请输入 例如:user"
            v-model="form.icon"
          >
            <a-icon slot="addonAfter" :type="form.icon" />
          </a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <Top />
  </div>
</template>
<script>
import {
  menu_list,
  menu_delete,
  menu_modify_status,
  menu_modify,
} from '@/api/menu'
import Top from '@/components/top'

export default {
  name: 'Menu',
  components: { Top },
  data() {
    return {
      // modal
      confirmLoading: false,
      visible: false,
      modalType: false, // false 添加 true 修改
      // from
      form: {
        id: undefined,
        isMenu: 0,
        parentPath: undefined,
        name: '',
        path: '',
        weigh: 0,
        switchStatus: true,
        icon: 'user',
      },
      rules: {
        name: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }],
        path: [{ required: true, message: '请输入菜单路径', trigger: 'blur' }],
        weigh: [{ required: true, message: '请设置权重', trigger: 'change' }],
        icon: [{ required: true, message: '请设置图标', trigger: 'blur' }],
      },
      // data
      list: [],
      loading: {
        size: 'large',
        spinning: false,
      },
    }
  },
  created() {
    this.$message.success({ content: '加载完毕', key: 'created' })
    this.getData()
  },
  methods: {
    getData() {
      this.loading.spinning = true
      menu_list().then((res) => {
        this.loading.spinning = false
        if (res.code === 1) {
          this.list = res.list
        }
      })
    },
    createMenu() {
      this.visible = true
      this.modalType = false
    },

    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true
          this.form.isMenu = this.form.switchStatus ? 1 : 0
          menu_modify(this.form)
            .then((res) => {
              if (res.code === 1) {
                this.visible = false
                this.confirmLoading = false
                this.getData()
                this.cancel()
              }
            })
            .catch(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    cancel() {
      // 取消修改 重置选项
      this.form.id = undefined
      this.form.parentPath = undefined
      this.form.name = ''
      this.form.path = ''
      this.form.weigh = 0
      this.form.icon = 'user'
      this.form.switchStatus = true
      this.$refs.ruleForm.resetFields()
    },
    modifyMenuStatus(id, status) {
      const type = status == 1 ? 'close' : 'open'
      menu_modify_status({ id: id, operate: type }).then((res) => {
        if (res.line === 0) {
          this.$message.warning({
            content: '无受影响行数,请刷新后再试',
            duration: 4,
          })
        } else {
          this.getData()
          this.$message.success(`受影响行数 ${res.line} 行`)
        }
      })
    },
    deleteMenu(id) {
      menu_delete({ id: id }).then((res) => {
        if (res.line === 0) {
          this.$message.warning({
            content: '无受影响行数,请刷新后再试',
            duration: 4,
          })
        } else {
          this.getData()
          this.$message.success(`删除 ${res.line} 条`)
        }
      })
    },
    changeMenu(record) {
      this.visible = true
      this.modalType = true
      this.form.switchStatus = !!record.is_menu
      // 写入需要修改的数据
      this.form.id = record.id

      if (this.$HelperUtil.isEmpty(record.parent_path)) {
        this.form.parentPath = undefined
      } else {
        this.form.parentPath = record.parent_path
      }

      this.form.name = record.name
      this.form.path = record.path
      this.form.weigh = record.weigh
      this.form.icon = record.icon
    },
  },
}
</script>
<style scoped lang="less"></style>
